export default "__VITE_ASSET__CMq1CHSJ__"